import React, { useState } from "react";
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaTrigger,
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@jammable/ui-components/Dialog";
import Link from "next/link";
import { FaComment, FaMusic, FaSearch, FaShare } from "react-icons/fa";
import useAuthModal from "@/hooks/useAuthModal";

const ConversionPageActionFlowMobile = ({ item, model, idx, isNew }) => {
  const renderChildrenWithProps = (children) => {
    return React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, { isOpen, setIsOpen });
      }
      return child;
    });
  };

  const iconStyle =
    "tw-w-16 tw-overflow-hidden tw-relative tw-h-16 tw-bg-teal-300 tw-rounded-5xl";
  const [isOpen, setIsOpen] = useState(false);
  const containerStyle =
    "tw-border tw-border-purple-300/30 tw-border-solid tw-items-start tw-justify-between tw-cursor-pointer tw-flex tw-flex-col-reverse md:tw-flex-row tw-p-4 tw-px-5 md:tw-p-5 tw-w-full tw-gap-2 md:tw-gap-4";
  const { checkAuthAndExecute } = useAuthModal();

  return item.name === "Duet" ? (
    <Link
      href={{
        pathname: `/duets`,
        query: { voices: model._id },
      }}
      key={idx}
      style={{}}
      className={`${containerStyle}  ${idx === 2 && "tw-rounded-bl-2xl"}`}
    >
      <div className="tw-flex tw-flex-col tw-h-full tw-py-1">
        <div className="tw-text-lg md:tw-text-xl tw-font-bold">{item.name}</div>
        <div className="tw-font-bold tw-opacity-40 tw-text-sm tw-mt-1 md:tw-mt-auto">
          {item.description}
        </div>
      </div>
      {item.icon ?? (
        <div className={iconStyle}>
          <FaMusic
            className="tw-text-purple-700 tw-absolute tw-left-5"
            size={50}
          />
        </div>
      )}
    </Link>
  ) : (
    <Dialog
      open={isOpen}
      onOpenChange={(e) => {
        if (!checkAuthAndExecute()) return false;
        setIsOpen(e);
      }}
      key={idx}
    >
      <DialogTrigger as={Link} href={`/`} asChild>
        <div
          key={idx}
          className={`${containerStyle} ${idx === 0 && "tw-rounded-tl-2xl"}  ${idx === 1 && "tw-rounded-tr-2xl"} ${idx === 2 && "tw-rounded-bl-2xl"}  ${idx === 3 && "tw-rounded-br-2xl"}`}
        >
          <div className="tw-flex tw-flex-col tw-h-full tw-py-1">
            <div className="tw-text-lg md:tw-text-xl tw-font-bold tw-flex">
              {item.name}
            </div>
            <div className="tw-font-bold  tw-text-sm tw-mt-1 md:tw-mt-auto tw-inline-flex">
              <span className="tw-opacity-40">{item.description}</span>
            </div>
          </div>
          {item.icon ?? (
            <div className={iconStyle}>
              <FaMusic
                className="tw-text-purple-700 tw-absolute tw-left-5"
                size={50}
              />
            </div>
          )}
        </div>
      </DialogTrigger>
      <DialogContent
        drawerMode
        className="max-w-lg tw-w-full tw-p-4 md:tw-p-6 md:tw-pb-6 tw-rounded-t-lg"
      >
        {renderChildrenWithProps(item.body)}
      </DialogContent>
    </Dialog>
  );
};

export default ConversionPageActionFlowMobile;
